import { FormGroup, FormControlLabel } from "@mui/material";
import styled from "styled-components";

export const ListContainer = styled.div`
  padding: 10px 12px;
  min-height: 400px;
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  padding: 14px 16px;
  width: 100%;
  justify-content: space-between;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
  padding: 12px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;
  justify-content: center;
`;

export const FormGroupComponent = styled(FormGroup)`
  width: 100%;
  margin-top: 6px;
`;

export const FormControlLabelComponent = styled(FormControlLabel)`
  width: 100%;
  margin: 6px 0px;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px 10px;

  @media (max-width: 780px) {
    grid-template-columns: 1fr;
  }
`;

export const FullRow = styled.div`
  grid-column: 1 / -1;
`;

export const HelperText = styled.small`
  display: block;
  color: ${(props) => props.theme.fonts.disable_text};
  margin-top: 4px;
`;
